import Vue from 'vue'
import Router from 'vue-router'
import Gallery from './views/Gallery.vue'
import PageTemplate from './views/PageTemplate.vue'
import Instructions from './views/Instructions.vue'
// import store from '../src/store.js'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'gallery',
      component: Gallery
    },
    {
      path: '/page/:slug',
      props: true,
      name: 'page-template',
      component: PageTemplate
    },
    {
      path: '/instructions',
      name: 'instructions',
      component: Instructions
    },
    {
      path: '*',
      component: Gallery
    }
  ]
})
